module.exports = __webpack_public_path__ + "static/media/signup-img-1.d7606abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/signup-img-1.jpg
// module id = 1407
// module chunks = 0